import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
} from "@angular/material/dialog";
import { Router } from "@angular/router";
import { NxButtonModule } from "@aposin/ng-aquila/button";
import { NxGridModule } from "@aposin/ng-aquila/grid";
import { TranslateModule } from "@ngx-translate/core";
import { Store } from "@ngxs/store";

@Component({
  selector: "app-common-modal",
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    NxButtonModule,
    NxGridModule,
    TranslateModule,
  ],
  templateUrl: "./common-modal.component.html",
  styleUrls: ["./common-modal.component.scss"],
})
export class CommonModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) protected data,
    private readonly matDialog: MatDialog,
    private readonly router: Router,
    private readonly store: Store,
  ) {}

  protected closeLeaveModal() {
    this.matDialog.closeAll();
  }
}
